"use client";

import Link from "next/link";

interface HeaderProps {
  name: string;
  desc: string;
  link?: string;
}

export default function Header({ name, desc, link }: HeaderProps) {
  return (
    <header className="relative bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-100/30 via-gray-100/30 to-gray-200/30 backdrop-blur-md shadow-lg">
      <div className="container mx-auto px-6 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Left side - Logo and Title */}
          <div className="flex items-center gap-5">
            <Link
              href={link || "/"}
              className="group relative rounded-xl p-2 transition-all duration-300 hover:bg-white/10"
            >
              <img
                src={process.env.basePath + "/BME.svg"}
                alt="BME logo"
                className="h-12 w-auto drop-shadow-lg transition-transform duration-300 group-hover:scale-105"
              />
            </Link>

            <div className="flex flex-col gap-1 rounded-xl bg-white/10 px-6 py-3 backdrop-blur-sm transition-all duration-300 hover:bg-white/15">
              <h1 className="bg-gradient-to-r from-bme-main via-[#e49756] to-[#e49756] bg-clip-text text-xl font-bold text-transparent sm:text-2xl">
                {name}
              </h1>
              <p className="hidden text-sm text-gray-700 sm:block">{desc}</p>
            </div>
          </div>

          {/* Right side - Navigation */}
          <div className="flex items-center gap-4">
            <Link
              href="/contact"
              className="hidden rounded-lg bg-white/10 px-5 py-2.5 text-gray-700 backdrop-blur-sm transition-all duration-300 hover:text-bme-main sm:block"
            >
              Kapcsolat
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom gradient line */}
      <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-bme-main to-transparent opacity-60"></div>
    </header>
  );
}
